import { useSelector } from 'react-redux';
var useUser = function () { return useSelector(function (_a) {
    var user = _a.user;
    return user;
}); };
export default useUser;
